import { type QueryHookOptions, useQuery } from "@apollo/client";
import { ChatBansQuery } from "../graphql/queries";
import type {
  ChatBansQueryType,
  ChatBansQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useChatBansQuery = (
  options?: QueryHookOptions<ChatBansQueryType, ChatBansQueryVariablesType>
) => {
  return useQuery<ChatBansQueryType, ChatBansQueryVariablesType>(
    ChatBansQuery,
    options
  );
};
